"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenService = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var index_1 = require("./index");
var TokenService = /** @class */ (function () {
    function TokenService() {
        this.__priority = 100;
        this.tokens = mobx_1.observable.map();
    }
    TokenService.prototype.init = function () {
        var _this = this;
        (0, mobx_1.reaction)(function () { return index_1.Services.Department.current; }, function () {
            _this.updateTokens();
        }, { name: 'TokenService:department' });
    };
    TokenService.prototype.updateTokens = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentDepartment, tokens;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentDepartment = index_1.Services.Department.current;
                        if (!(currentDepartment == null)) return [3 /*break*/, 1];
                        this.tokens.clear();
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, index_1.Services.Department.rest.tokens.fetch()];
                    case 2:
                        tokens = _a.sent();
                        this.setTokens(tokens);
                        _a.label = 3;
                    case 3:
                        index_1.Services.Route.tokensLoaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.setTokens = function (tokens) {
        this.tokens.clear();
        for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
            var t = tokens_1[_i];
            this.tokens.set(t.name, t.name);
        }
    };
    TokenService.prototype.has = function (token) {
        return this.tokens.has(token);
    };
    TokenService.prototype.hasAll = function (tokens) {
        tokens = Array.isArray(tokens) ? tokens : [];
        for (var _i = 0, tokens_2 = tokens; _i < tokens_2.length; _i++) {
            var token = tokens_2[_i];
            if (!this.tokens.has(token)) {
                return false;
            }
        }
        return true;
    };
    TokenService.prototype.getByPrefix = function (prefix) {
        var tokens = Array.from(this.tokens.keys());
        return tokens.filter(function (token) { return token.startsWith(prefix); });
    };
    tslib_1.__decorate([
        mobx_1.action
    ], TokenService.prototype, "updateTokens", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TokenService.prototype, "setTokens", null);
    return TokenService;
}());
exports.TokenService = TokenService;
//# sourceMappingURL=token.service.js.map